import { styled } from "@mui/material";
import { Paper, Typography, Box } from "@mui/material";

export const PageWrapper = styled("div")({
  width: "100%",
});

export const PortraitLogoContainer = styled("div")(({ theme }) => ({
  background: theme.palette.color.main.primary,
  borderRadius: "1.5rem",
  padding: "1.3rem 1.9rem 1.5rem 1.65rem",

  "& img": {
    width: "4rem",
  },

  "@media only screen and (max-width: 767px)": {
    padding: "1.35rem 1.8rem",
    "& IMG": {
      width: "4rem",
    },
  },
}));

export const LandscapeLogoContainer = styled("div")(({ theme }) => ({
  background: theme.palette.color.main.primary,
  borderRadius: "5rem",
  padding: "1rem 2rem 0.75rem 1.75rem",

  "& img": {
    width: "6rem",
  },

  "@media only screen and (max-width: 767px)": {
    padding: "0.75rem 1.5rem 0.5rem 1.25rem",
    "& IMG": {
      width: "4rem",
    },
  },
}));

export const HeroSection = styled("div")({
  position: "relative",
  minHeight: "500px",
  width: "100%",
  padding: "2rem 2rem 0 2rem",
});

export const ContentArea = styled("div")({
  position: "relative",
  padding: "4rem",
  background:
    "linear-gradient(-45deg, #E1F5FF 0%, #C8EDFF 25%, #F2FAFF 45%, #D9F0FC 55%, #F1FAFF 75%, #EFF6F9 100%)",
  backgroundSize: "400% 400%",
  animation: "gradient 15s ease infinite",
  borderRadius: "3rem",

  "@keyframes gradient": {
    "0%": {
      backgroundPosition: "0% 50%",
    },
    "50%": {
      backgroundPosition: "100% 50%",
    },
    "100%": {
      backgroundPosition: "0% 50%",
    },
  },

  "@media (max-width: 980px)": {
    padding: "1.5rem",
  },
});

export const HeaderContainer = styled("div")({
  width: "100%",
  marginBottom: "2rem",
  display: "flex",
  justifyContent: "start",
});

export const FormContainer = styled("div")(({ theme }) => ({
  width: "100%",
  display: "flex",
  gap: "40px",

  "& #FormContent": {
    textAlign: "center", // Center the form container itself
    flexGrow: 1,
    flexBasis: 0,

    // But labels and form fields should be left-aligned
    "& .MuiFormControl-root, & label": {
      textAlign: "left",
    },
  },

  "& #FormInfo": {
    display: "flex",
    flexDirection: "column",
    paddingTop: "2rem",
    flexGrow: 1,
    flexBasis: 0,

    "& h1": {
      fontSize: "4rem",
      lineHeight: "3.5rem",
      margin: "0 0 1rem 0",
      fontWeight: 500,
    },

    "& p": {
      margin: "0.65rem 0",

      "&.checkitem": {
        color: theme.palette.color.main.primary,
        margin: "0.2rem 0",

        "& svg": {
          color: theme.palette.color.main.primary,
          marginTop: "-4px",
        },
      },

      "& strong": {
        "& a": {
          fontWeight: 700,
          color: theme.palette.color.main.primary,
        },
      },
    },
  },

  "& #FreeReportForm": {
    background: "white",
    border: `2px solid ${theme.palette.color.main.primary}`,

    "& h4": {
      fontSize: "3rem",
      fontFamily: "var(--font-hl)",
      fontWeight: 500,
      color: theme.palette.color.main.primary,
      textAlign: "center",
    },

    "& h6": {
      color: theme.palette.color.content.textDark,
      fontSize: "0.75rem",
      marginBottom: 0,
      padding: "0.25rem",
      fontWeight: 500,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",

      "& i": {
        color: theme.palette.color.main.secondary,
        opacity: 0.5, // Updated to match commit's rgba(var(--color-secondary),0.5)
        transition: "0.25s ease",

        "&:hover": {
          color: theme.palette.color.main.primary,
          opacity: 1,
          transition: "0.25s ease",
        },
      },
    },

    "& .MuiTooltip-popperArrow": {
      background: "red",
    },
  },

  "& .MuiContainer-root": {
    padding: 0,
  },

  "@media (max-width: 980px)": {
    flexDirection: "column",

    "& #FormInfo": {
      paddingTop: 0,

      "& h1": {
        fontSize: "3rem",
        lineHeight: "2.75rem",
      },
    },
  },

  "@media (max-width: 720px)": {
    "& #FormInfo h1": {
      fontSize: "2rem",
      lineHeight: "1.5rem",
    },

    "& .navbar-brand": {
      zoom: 0.75,
    },
  },
}));

export const AdditionalContent = styled("div")({
  maxWidth: "1200px",
  margin: "0 auto",
  padding: "2rem 2rem 0 2rem",
});

export const InfoBlock = styled("div")(({ theme }) => ({
  width: "100%",
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "2rem",
  alignItems: "stretch",
  justifyContent: "center",
  textAlign: "center",
  color: "#333",
  fontWeight: "bold",
  marginTop: 0,
  marginBottom: "1.5rem",

  "@media (max-width: 720px)": {
    gridTemplateColumns: "1fr",
    gap: "1rem",
  },

  "& .info": {
    padding: "2rem",
    borderRadius: "1rem",
    width: "100%",

    "& h3": {
      color: theme.palette.color.main.primary,
      margin: "0 0.5rem 0.5rem 0.5rem",
    },

    "& p": {
      textAlign: "left",
    },

    "&.left": {
      background: theme.palette.color.content.background || "#EFF6F9",
    },

    "&.right": {
      background: theme.palette.color.content.background || "#EFF6F9",
    },
  },
}));

// Free Report Form styled components
export const FormContainerStyled = styled(Paper)({
  padding: "2rem",
  backgroundColor: "white",
  borderRadius: "1rem", // Updated from 1.75rem to match commit

  "@media (max-width: 720px)": {
    padding: "1rem",
    paddingBottom: "2rem",
  },
});

export const FormTitle = styled(Typography)({
  "& span": {
    color: "#5050f9",
  },
  textAlign: "center",
  marginBottom: "2rem",

  "@media (max-width: 720px)": {
    marginBottom: "1rem",
  },
});

export const FormSubtitle = styled(Typography)({
  fontSize: "0.9375rem",
  marginBottom: "0.5rem",
  fontWeight: 700,
});

export const BenefitsContainer = styled(Box)({
  marginBottom: "1.5rem",
  marginLeft: "1rem",

  "@media (max-width: 720px)": {
    marginLeft: 0,
    fontSize: "0.75rem",
  },
});

export const BenefitItem = styled(Box)({
  display: "flex",
  alignItems: "center",
  marginBottom: "0.5rem",

  "&:last-child": {
    marginBottom: 0,
  },
});

export const BenefitIcon = styled("span")({
  color: "#4caf50",
  marginRight: "0.5rem",
});

export const BenefitText = styled(Typography)({
  fontSize: "1rem",

  "@media (max-width: 720px)": {
    fontSize: "0.875rem",
  },
});

export const FormWrapper = styled(Box)({
  marginTop: "2rem",
});

export const FormRow = styled(Box)({
  display: "flex",
  flexDirection: "row",
  gap: "2rem",
  marginBottom: "1rem",

  "@media (max-width: 900px)": {
    flexDirection: "column",
  },
});

export const FormField = styled(Box)({
  flexGrow: 1,
});

export const FieldLabel = styled(Typography)({
  marginBottom: "0.5rem",
  textAlign: "left", // Labels should be left-aligned, not centered
});

export const FormSection = styled(Box)({
  marginBottom: "1rem",
});

export const TermsSection = styled(Box)({
  marginBottom: "1.5rem",
});

export const SubmitContainer = styled(Box)({
  display: "flex",
  justifyContent: "center",
});

export const FAQBlock = styled("div")(({ theme }) => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  color: "#333",
  fontWeight: "bold",
  marginTop: 0,
  marginBottom: 0,

  "& #faq": {
    background: `linear-gradient(-45deg, rgba(193,234,244,0.25), rgba(193,234,244,0.5))`,
    borderRadius: "1rem",
    padding: "1rem 2rem 2rem 2rem",

    "& .faqBlock": {
      "& .header": {
        display: "flex",
        justifyContent: "space-between",
        padding: "1rem 0",
        borderBottom: "1px solid rgba(193,234,244,0.25)",

        "& h4": {
          margin: 0,
        },

        "& span": {
          transition: "0.25s ease",
        },
      },

      "& p": {
        display: "none",
        textAlign: "left",
      },

      "&.active": {
        "& .header": {
          "& h4": {
            color: theme.palette.color.main.primary,
          },
          "& span": {
            transform: "rotate(180deg)",
            transition: "0.25s ease",
          },
        },
        "& p": {
          display: "inline-block",
        },
      },
    },
  },

  "@media (max-width: 720px)": {
    "& #faq": {
      padding: "0 1rem",
    },
  },
}));
